var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEyedropper(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "eyedropper",
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.552,
    height: 12.552,
    viewBox: "0 0 12.552 12.552",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_64210",
    "data-name": "Path 64210",
    d: "M5.027,5.621.8,9.852v2.034l-.753.753,1.112,1.112L1.908,13H3.942L8.173,8.768Z",
    transform: "translate(-0.043 -1.2)",
    fill: "#999"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_64211",
    "data-name": "Path 64211",
    d: "M11.8,7.636l1.112-1.112-1.18-1.18L13.277,3.8A2.225,2.225,0,1,0,10.13.652L8.585,2.2l-1.18-1.18L6.293,2.129Z",
    transform: "translate(-1.377 0)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyedropper);
export default __webpack_public_path__ + "static/media/eyedropper.6a984666291dc6a403e55ccd7a25ede3.svg";
export { ForwardRef as ReactComponent };